import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dollar-simple",
  "use": "dollar-simple-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 40 40\" id=\"dollar-simple\"><rect width=\"40\" height=\"40\" fill=\"#7257FA\" fill-opacity=\".1\" rx=\"4\" /><path stroke=\"#7257FA\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M20 10.25v2.25m0 15v2.25m5.25-13.5a3.75 3.75 0 0 0-3.75-3.75h-3.375a3.75 3.75 0 0 0 0 7.5h4.125a3.75 3.75 0 0 1 0 7.5h-4.5A3.75 3.75 0 0 1 14 23.75\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol